var map = {
	"./BNB Smart Chain.svg": 73987,
	"./Cosmos.svg": 57523,
	"./Ethereum.svg": 4124,
	"./Harmony.svg": 85159,
	"./Kusama.svg": 28473,
	"./Minima.svg": 5152,
	"./Moonriver.svg": 77450,
	"./Near.svg": 63129,
	"./Polygon.svg": 86047,
	"./Solana.svg": 51759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29097;